import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 16px 32px 0;
  max-width: 414px;
  margin: 0 auto;
`;

export const PageTitle = styled.h2`
  font-family: var(--font-family-base);
  font-size: 20px;
  font-weight: 600;
  color: var(--title-color);
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const PageSubtitle = styled.p`
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  color: var(--text-color);
  line-height: 1.5;
  letter-spacing: -0.28px;
  margin-bottom: 24px;
  opacity: 0.8;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 16px 24px;
  background-color: var(--primary-color);
  color: var(--button-primary-text);
  border: none;
  border-radius: 4px;
  font-family: var(--font-family-base);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
  cursor: pointer;
  margin-top: 8px;
  margin-bottom: 24px;

  &:disabled {
    background-color: var(--button-disabled-color) !important;
    cursor: not-allowed;
    opacity: 1;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
